import { render } from "./CustomSelectCurator.vue?vue&type=template&id=633adfca"
import script from "./CustomSelectCurator.vue?vue&type=script&lang=js"
export * from "./CustomSelectCurator.vue?vue&type=script&lang=js"

import "./CustomSelectCurator.vue?vue&type=style&index=0&id=633adfca&lang=css"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__